import React, { ReactNode, useCallback, useMemo, useState } from 'react';
import { FormInstance, Radio, RadioChangeEvent } from 'antd';
import { useTranslation } from 'react-i18next';
import { DeviceActionStepsProps } from '@components/Actions/ActionsModal/types';
import useManualImportStep from './useManualImportStep';

const useSimcardImportStep = (
  actionKey: number | undefined,
  form: FormInstance<any> | undefined,
  uploadContent: ReactNode,
  isLoraWan?: boolean,
): DeviceActionStepsProps => {
  const { t } = useTranslation('actions-modal');
  const [importType, setImportType] = useState<'upload' | 'manual'>('upload');

  const radioGroupOptions = useMemo(
    () => [
      {
        label: t('simcard-import.csv-file'),
        value: 'upload',
      },
      {
        label: t('simcard-import.manually.title'),
        value: 'manual',
      },
    ],
    [t],
  );

  const manualImport = useManualImportStep(actionKey, form, isLoraWan);

  const handleRadioChange = useCallback(
    ({ target: { value } }: RadioChangeEvent) => {
      setImportType(value);
      form?.resetFields();
    },
    [form],
  );

  return {
    title: t('simcard-import.how-to-import'),
    name: 'uploadedItems',
    showWhenUpload: true,
    content: (
      <>
        <Radio.Group
          optionType="button"
          defaultValue="upload"
          value={importType}
          onChange={handleRadioChange}
          options={radioGroupOptions}
          style={{ marginBottom: 24 }}
        />
        {importType === 'upload' ? uploadContent : manualImport}
      </>
    ),
  };
};

export default useSimcardImportStep;
